module.exports = __webpack_public_path__ + "assets/img/characteristics-box1-img.836df19d.png";